// extracted by mini-css-extract-plugin
export default {"root":"ExpandableSearchBar_root__2hxJX","popUp":"ExpandableSearchBar_popUp__1LzSl","clearIcon":"ExpandableSearchBar_clearIcon__2SMoK"};